<template>
  <div>
    <div
      v-show="isContentUploadProgressContainerDisplayed"
      id="content-upload-progress-container"
      ref="content-upload-progress-container"
    >
      <div
        v-show="isContentUploadeInProgressDisplayed"
        id="content-upload-in-progress"
        ref="content-upload-in-progress"
        class="h-100"
      >
        <p
          class="font-weight-bold"
        >
          Content Upload in Progress
        </p>
        <div class="progress mb-5">
          <div
            id="content-upload-progress-bar"
            class="progress-bar bg-success"
            role="progressbar"
            :style="`width: ${uploadedPercentage}`"
            :aria-valuenow="uploadedPercentage"
            aria-valuemin="0"
            aria-valuemax="100"
          />
        </div>
        <div
          id="email-me-checkbox-container"
          class="d-flex"
        >
          <input
            id="email-me-on-complete"
            name="email-me-on-complete"
            type="checkbox"
            :checked="emailOnCompletion"
            @change="emailUserOnComplete($event.target.checked)"
          >
          <label
            for="email-me-on-complete"
            class="mb-0 ml-1"
          >
            Email me when complete
          </label>
        </div>
      </div>
      <div
        v-show="isContentUploadCompleteDisplayed"
        id="content-upload-complete"
        ref="content-upload-complete"
        class="content-upload-complete h-100 py-4"
      >
        <div
          class="h-100 d-inline-flex flex-column align-items-center"
        >
          <div
            height="30px"
            class="flex-shrink-0"
          >
            <i
              id="upload-complete-check"
              ref="upload-complete-check"
              class="upload-complete-check fa-solid fa-check fa-2xl text-success"
            />
          </div>
          <p
            class="font-weight-bold flex-grow-0 flex-shrink-0 mb-0"
          >
            Upload Complete
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import gsap from 'gsap';
import { mapActions, mapState } from 'vuex';
import * as contentTypes from '@/modules/content/store/types';

export default {
  name: 'UploadProgressAnimationBox',
  data() {
    return {
      isContentUploadProgressContainerDisplayed: false,
      isContentUploadeInProgressDisplayed: true,
      isContentUploadCompleteDisplayed: false,
    };
  },
  computed: {
    ...mapState('campaigns', [
      'campaign',
      'selectedAdvertiser',
    ]),
    ...mapState('content', [
      'inProgressContentScrapes',
      'emailOnCompletion',
      'scrapingBatchId',
    ]),
    uploadedPercentage() {
      if ((!this.inProgressContentScrapes.contentItems.length
      || !this.inProgressContentScrapes.totalStartLength)
      && !this.isContentUploadProgressContainerDisplayed) return '0%';
      this.displayProgress();
      const finishedUploading = this.inProgressContentScrapes.totalStartLength - this.inProgressContentScrapes.contentItems.length;
      const progressPercentage = Math.ceil((finishedUploading * 100) / this.inProgressContentScrapes.totalStartLength);
      if (this.inProgressContentScrapes.totalStartLength === 0) {
        this.startUploadCompleteAnimation();
        return '100%';
      }
      return `${progressPercentage}%`;
    },
  },
  methods: {
    ...mapActions('content', [
      contentTypes.RESCRAPE_CONTENT,
      contentTypes.SET_EMAIL_USER_ON_SCRAPE_COMPLETION,
    ]),
    displayProgress() {
      this.isContentUploadProgressContainerDisplayed = true;
      this.isContentUploadeInProgressDisplayed = true;
    },
    startUploadCompleteAnimation() {
      const scope = this;
      const completeAnimationTimeLine = gsap.timeline({ defaults: { duration: 0.3 } });
      completeAnimationTimeLine
        .to(this.$refs['content-upload-in-progress'], { opacity: 0, delay: 1, ease: 'power1.inOut' })
        .call(() => {
          scope.isContentUploadeInProgressDisplayed = false;
          scope.isContentUploadCompleteDisplayed = true;
        }, null, '>0.3')
        .to(this.$refs['content-upload-complete'], { opacity: 1 })
        .to(this.$refs['upload-complete-check'], { opacity: 1, fontSize: '2em' }, '<0.1')
        .to(this.$refs['content-upload-complete'], { opacity: 0 }, '>1')
        .call(() => {
          scope.isContentUploadCompleteDisplayed = false;
        }, null, '>0.3')
        .to(this.$refs['content-upload-progress-container'], {
          height: '0px',
          delay: 1,
          onComplete: () => {
            scope.isContentUploadProgressContainerDisplayed = false;
            this.$refs['content-upload-in-progress']?.style.removeProperty('opacity');
            this.$refs['content-upload-complete']?.style.removeProperty('opacity');
            this.$refs['content-upload-progress-container']?.style.removeProperty('height');
          },
        });
    },
    emailUserOnComplete(checked) {
      const rescrapingPayload = {
        advertisersId: this.selectedAdvertiser.id,
        feedId: this.campaign.feedId,
        contentScrapeId: this.scrapingBatchId,
        emailOnCompletion: checked,
        campaignId: this.campaign.id,
      };
      this.RESCRAPE_CONTENT(rescrapingPayload);
    },
  },
};
</script>
<style lang="scss" scoped>
#email-me-checkbox-container {
  padding: inherit
}
.content-upload-complete {
  opacity: 0;
}
.upload-complete-check {
  opacity: 0;
  font-size: 0;
}
</style>
